const menuItems = [
	{ label: "Rezerwacja klienta", to: "/" },
	{ label: "Regulamin", to: "/regulamin-client" },
	{ label: "Kontakt", to: "/kontakt-client" },
	{ label: "Wyloguj", action: "logout" },
	{ type: "divider", moderatorOnly: true },
	{ label: "Admin Kontakt", to: "/kontakt", adminOnly: true },
	{ label: "Admin Regulamin", to: "/regulamin", adminOnly: true },
    { label: "Admin Cennik", to: "/price-list", adminOnly: true },
	{ label: "Admin Rezerwacje", to: "/adm", moderatorOnly: true },
	{ label: "Admin Uzytkownicy", to: "/users", adminOnly: true },
    

];

export default menuItems;
